import React from 'react';
import { Typography, Grid, Link } from '@material-ui/core';
import config from '../../config/config.json';

export default function (props) {
    const ejemplo = [
        [
            { campo: 'id', tipo: 'integer', valor: '1', descripcion: 'Identificador del proyecto.' },
            { campo: 'titulo', tipo: 'string', valor: 'Infraestructura de Datos Espacial, en aplicación de la sostenibilidad de la climatología de montaña en la región oriental de Cuba', descripcion: 'Título del proyecto.' },
            { campo: 'programa', tipo: 'string', valor: 'Cambio Climático en Cuba: Meteorología y Desarrollo Sostenible del País', descripcion: 'Programa al que pertenece el proyecto.' },
            { campo: 'entidad_principal', tipo: 'string', valor: 'Centro Meteorológico Provincial de Santiago de Cuba', descripcion: 'Entidad principal' },
            { campo: 'fecha_inicio', tipo: 'date', valor: '2020-01-01', descripcion: 'Fecha de inicio.' },
            { campo: 'fecha_fin', tipo: 'date', valor: '2022-12-31', descripcion: 'Fecha de culminación del proyecto.' },
            { campo: 'jefe', tipo: 'string', valor: 'José Ramón Cid Nacer', descripcion: 'Jefe del proyecto.' },
        ],
        [
            { campo: 'id', tipo: '', valor: '3', descripcion: '' },
            { campo: 'titulo', tipo: '', valor: 'Clima de Montaña', descripcion: '' },
            { campo: 'programa', tipo: '', valor: 'Cambio Climatico', descripcion: '' },
            { campo: 'entidad_principal', tipo: '', valor: 'Centro Meteorologico Provincial de Santiago de Cuba', descripcion: '' },
            { campo: 'fecha_inicio', tipo: '', valor: '2018-01-01', descripcion: '' },
            { campo: 'fecha_fin', tipo: '', valor: '2021-12-31', descripcion: '' },
            { campo: 'jefe', tipo: '', valor: 'Ursinio Montenegro Moracén', descripcion: '' },
        ],
    ];

    return (
        <>
            <Typography variant="h5" color="initial">
                <code>
                    Proyectos
                </code>
            </Typography>
            <br />

            <Typography variant="subtitle2" color="initial">
                Proyectos que dirige o en los que participa la entidad.
            </Typography>
            <br />

            <Grid container spacing={1}>
                <Grid item sm={1}>
                    <Typography variant="subtitle1" className="getMethod">GET</Typography>
                </Grid>
                <Grid item sm={8}>
                    <Typography variant="subtitle1" className="endPoint">/proyectos</Typography>
                </Grid>
                <Grid item sm={3}>
                    <Typography variant="subtitle1" color="primary">
                        <Link href={`${config.apiBaseUrl}/proyectos`} target="_blank">
                            Pruébalo
                            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M12.7928 8.50002L8.64637 12.6465L9.35348 13.3536L14.707 8.00004L9.35348 2.64648L8.64637 3.35359L12.7928 7.50002H3V8.50002H12.7928Z" fill="#3f51b5">
                                </path>
                            </svg>
                        </Link>
                    </Typography>
                </Grid>
            </Grid>
            <br />

            <pre>
                {config.apiBaseUrl}/proyectos
            </pre>
            <br />

            <Typography paragraph variant="body2">
                Devuelve una lista de proyectos en los que dirige o participa la entidad, si existen; de lo contrario una lista vacía <code>[ ]</code>. Donde cada proyecto es representada por un objeto.
            </Typography>
            <br />

            <Typography variant="h6" color="initial">
                Ejemplo: <br /> {/* Ejemplo de respuesta */}
                {/* con un Tabs de mui mostrar [cuerpo, cabecera] */}
            </Typography>
            <br />
            <pre>
                [
                {
                    ejemplo.map((item) => (
                        <>
                            <div>{`{`}</div>
                            {
                                item.map((subitem) => (
                                    <div><span className="pre-key">"{subitem.campo}"</span>: <span className="pre-value">"{subitem.valor}",</span></div>
                                ))
                            }
                            <div>{`}`},</div>
                        </>
                    ))
                }
                ]
            </pre>

            <Typography variant="subtitle1" color="initial">
                Cada objeto esta formado por:
            </Typography>
            <br />

            <table className="table table-striped table-bordered table-hover">
                <thead>
                    <tr>
                        <th>Campo</th>
                        <th>Tipo</th>
                        <th>Descripción</th>
                    </tr>
                </thead>
                <tbody>
                    {
                        ejemplo.map((item, index) => {
                            if (index == 0) {
                                return (
                                    item.map((subitem) => (
                                        <tr>
                                            <td>{subitem.campo}</td>
                                            <td>{subitem.tipo}</td>
                                            <td>{subitem.descripcion}</td>
                                        </tr>
                                    ))
                                )
                            }
                        })
                    }
                </tbody>
            </table>
            <br />

            {/* otro ejemplo de peticion */}
            <Typography variant="h6" color="initial">
                <code>
                    Obteniendo un proyecto específico.
                </code>
            </Typography>
            <br />

            <Grid container spacing={1}>
                <Grid item sm={1}>
                    <Typography variant="subtitle1" className="getMethod">GET</Typography>
                </Grid>
                <Grid item sm={8}>
                    <Typography variant="subtitle1" className="endPoint">/proyectos/{`{`}identificador{`}`}</Typography>
                </Grid>
                <Grid item sm={3}>
                    <Typography variant="subtitle1" color="primary">
                        <Link href={`${config.apiBaseUrl}/proyectos/1`} target="_blank">
                            Pruébalo
                            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M12.7928 8.50002L8.64637 12.6465L9.35348 13.3536L14.707 8.00004L9.35348 2.64648L8.64637 3.35359L12.7928 7.50002H3V8.50002H12.7928Z" fill="#3f51b5">
                                </path>
                            </svg>
                        </Link>
                    </Typography>
                </Grid>
            </Grid>
            <br />

            <pre>
                {config.apiBaseUrl}/proyectos/{`{`}identificador{`}`}
            </pre>
            <br />

            <Typography paragraph variant="body2">
                Devuelve un proyecto dado su <code>{`{ `}identificador{` }`}</code> si es que existe. Este proyecto está representado por un objeto de la forma: <code>(ver tabla anterior)</code>.
            </Typography>
            <br />

            <Typography variant="subtitle1" color="initial">
                Ejemplo de url para obtener el proyecto con identficador igual a 1: <br />
            </Typography>
            <br />

            <pre>
                {config.apiBaseUrl}/proyectos/1
            </pre>
            <br />

            <Typography variant="subtitle1" color="initial">
                Respuesta: <br />
            </Typography>
            <br />
            <pre>
                {
                    ejemplo.map((item, index) => {
                        if (index == 0) {
                            return (
                                <>
                                    <div>{`{`}</div>
                                    {
                                        item.map((subitem) => (
                                            <div><span className="pre-key">"{subitem.campo}"</span>: <span className="pre-value">"{subitem.valor}",</span></div>
                                        ))
                                    }
                                    <div>{`}`}</div>
                                </>
                            )
                        }
                    })
                }
            </pre>

            <Typography variant="subtitle1" color="initial">
                Posible error:
            </Typography>
            <br />
            <table className="table table-striped table-bordered table-hover">
                <thead>
                    <tr>
                        <th>Código de error</th>
                        <th>Descripción</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td>404 Recurso no encontrado</td>
                        <td>Ocurre cuando se intenta listar un proyecto cuyo identificador no existe o no es válido.</td>
                    </tr>
                </tbody>
            </table>
        </>
    )
}